import { Component, inject, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { EventsService } from '../../../data-services/events.service';
import { EventDetailed } from '../../../data-services/models/events/event-detailed.model';
import { ActivatedRoute } from '@angular/router';
import { EventsSummaryComponent } from '../../summary/feature/summary.component';
import { EventParchmentInviteComponent } from "../../parchment-invite/feature/parchment-invite.component";
import { TabsModule } from 'primeng/tabs';
import { EventBookingBasic } from '../../../data-services/models/event-bookings/event-booking-basic.model';
import { AttendeeListComponent } from '../attendee-list/feature/attendee-list.component';
import { EventBookingComponent } from "../../book/feature/book.component";
import { Store } from '@ngrx/store';
import { selectEvent } from '../../../data-services/stores/selectors/events.selectors';
import { EventActions } from '../../../data-services/stores/actions/events.actions';
import { LoadingComponent } from '../../../loading/feature/loading.component';
import { AuthService } from '../../../data-services/auth.service';
import { BoilerplateComponent } from '../../../core/boilerplate/feature/boilerplate.component';
import { MetaDataService } from '../../../data-services/metadata.service';
import { EventBasic } from '../../../data-services/models/events/event-basic.model';
import { tap } from 'rxjs';
import { CateringDatesPipe } from '../../../data-services/pipes/catering-dates.pipe';
import { SanitizedHtmlPipe } from '../../../data-services/pipes/sanitized-html.pipe';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-show',
  imports: [BoilerplateComponent, CommonModule, EventsSummaryComponent, EventParchmentInviteComponent, TabsModule, AttendeeListComponent, LoadingComponent, CateringDatesPipe, SanitizedHtmlPipe],
    templateUrl: '../ui/show.component.html',
    styleUrl: '../ui/show.component.css'
})
export class ShowComponent implements OnInit {
  private readonly _metaDataService = inject(MetaDataService);
  private readonly _titleService = inject(Title);
  private readonly _route = inject(ActivatedRoute);
  private readonly _authService = inject(AuthService);
  private readonly _store = inject(Store);

  event$ = this._store.select(selectEvent(this._route.snapshot.params["id"])).pipe(tap(lrpEvent => 
  {
    if (lrpEvent) {
      if (this.loggedIn){
        this._store.dispatch(EventActions.getAttendees({ eventID: lrpEvent?.eventID }))
      }
      if (!lrpEvent.eventTickets){
        this._store.dispatch(EventActions.loadSingleEvent({ eventRef: this._route.snapshot.params["id"], refresh: true}));
      }
    }
    else{
      this._store.dispatch(EventActions.loadSingleEvent({ eventRef: this._route.snapshot.params["id"], refresh: false}));
    }
      
      this._titleService.setTitle('LRPTickets.co.uk | ' + (lrpEvent?.eventHost.eventSystem.name) + (lrpEvent?.eventHost.display ? ' - ' + lrpEvent?.eventHost.name + ' | ' : ' | ') + lrpEvent?.name)
  }));
  loggedIn: boolean = this._authService.checkTokenExpiry();
  activeTab: string = 'invitation'
  eventLink: string = this._route.snapshot.params["id"];
  
  ngOnInit(): void {   
    this._route.data.subscribe(data => {
      if (data['bookingTab']) {
        this.activeTab = 'booking'
      }
    })
  }

  parseDate(input: Date): Date{
    return new Date(input)
  }
}
